module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "pn",
    attrs: {
      "id": "part2"
    }
  }, [_c('a', {
    attrs: {
      "id": "p72"
    }
  }), _c('a', {
    attrs: {
      "id": "p73"
    }
  }), _vm._v("PART II")]), _vm._v(" "), _c('p', {
    staticClass: "pt-orna"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pt-ornament.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pt"
  }, [_vm._v("GAME OF THRONES")]), _vm._v(" "), _c('p', {
    staticClass: "pt-epi"
  }, [_c('i', [_vm._v("‘When you play the game of thrones, you win or you die. There is no middle ground.’")])]), _vm._v(" "), _c('p', {
    staticClass: "pt-epi-credit"
  }, [_vm._v("Cersei Lannister to Eddard Stark, "), _c('i', [_vm._v("Game of Thrones")]), _vm._v(", series 1, episode 7 (2011)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ff03b868","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/part_02.vue
// module id = 93
// module chunks = 0